import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import {
    setImportCode,
    setImportFile,
    resetImportExcelState,
} from '../../store/slices/excel/importExcelSlice';

import useLoading from '../useLoading';
import useAlerts from '../useAlerts';
import useApiErrorHandler from '../useApiErrorHandler';
import ImportExcelService from '../../services/import/ImportExcelService';
import useModals from '../useModals';

/**
 * Hook para gestionar la importación dinámica de archivos Excel.
 */
export const useImportExcel = () => {
    const dispatch: AppDispatch = useDispatch();
    const { showLoadingIndicator, hideLoadingIndicator } = useLoading();
    const { show: showAlert } = useAlerts();
    const { openModal } = useModals();
    const { handle } = useApiErrorHandler();

    const { importCode, file } = useSelector(
        (state: RootState) => state.importExcel
    );

    const handlerSetImportCode = (code: string) => {
        dispatch(setImportCode(code));
    };

    const handlerSetImportFile = (file: File | null) => {
        dispatch(setImportFile(file));
    };

    const handlerResetImportState = () => {
        dispatch(resetImportExcelState());
    };

    const handlerImportExcel = async () => {
        if (!file || !importCode) {
            showAlert('warning', 'Importación incompleta', 'Debes seleccionar un archivo y un tipo de importación.');
            return;
        }

        try {
            showLoadingIndicator();
            const response = await ImportExcelService.importExcel(file, importCode);
            const { statusCode, title, message, type } = response;

            if (statusCode === 200) {
                openModal(type, { title, message });

                // ✅ Limpiar Redux y resetear input
                handlerResetImportState(); // Limpia file e importCode en el store
            }
        } catch (error) {
            handle(error);
        } finally {
            hideLoadingIndicator();
        }
    };



    return {
        importCode,
        file,
        handlerSetImportCode,
        handlerSetImportFile,
        handlerResetImportState,
        handlerImportExcel,
    };
};
